// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 프로필 페이지 스타일 */
.profile-container {
  min-height: 100vh;
  background: #f7fafc;
  padding: 40px 20px;
}

.profile-wrapper {
  max-width: 800px;
  margin: 0 auto;
}

.profile-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
}

.profile-header h1 {
  font-size: 32px;
  font-weight: bold;
  color: #2d3748;
}

.logout-btn {
  background: #e53e3e;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;
}

.logout-btn:hover {
  background: #c53030;
}

.message {
  padding: 12px 16px;
  border-radius: 6px;
  margin-bottom: 20px;
  font-size: 14px;
}

.message.success {
  background: #c6f6d5;
  color: #22543d;
  border: 1px solid #9ae6b4;
}

.message.error {
  background: #fed7d7;
  color: #9b2c2c;
  border: 1px solid #fc8181;
}

.profile-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.profile-section {
  padding: 32px;
  border-bottom: 1px solid #e2e8f0;
}

.profile-section:last-child {
  border-bottom: none;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.section-header h2 {
  font-size: 20px;
  font-weight: 600;
  color: #2d3748;
}

.edit-btn {
  background: #667eea;
  color: white;
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;
}

.edit-btn:hover {
  background: #5a67d8;
}

/* 프로필 정보 표시 */
.profile-info {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.info-item {
  display: grid;
  grid-template-columns: 120px 1fr;
  gap: 16px;
  padding: 12px 0;
  border-bottom: 1px solid #f7fafc;
}

.info-item:last-child {
  border-bottom: none;
}

.info-item .label {
  font-weight: 500;
  color: #718096;
  font-size: 14px;
}

.info-item .value {
  color: #2d3748;
  font-size: 14px;
}

/* 프로필 수정 폼 */
.profile-form,
.password-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.profile-form .form-group,
.password-form .form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.profile-form label,
.password-form label {
  font-size: 14px;
  font-weight: 500;
  color: #4a5568;
}

.profile-form input,
.profile-form select,
.password-form input {
  padding: 10px 14px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 14px;
  transition: all 0.2s;
  outline: none;
}

.profile-form input:focus,
.profile-form select:focus,
.password-form input:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.profile-form input.error,
.password-form input.error {
  border-color: #fc8181;
}

.profile-form input:disabled,
.profile-form select:disabled,
.password-form input:disabled {
  background-color: #f7fafc;
  cursor: not-allowed;
}

.error-text {
  font-size: 12px;
  color: #e53e3e;
}

.form-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 12px;
}

.cancel-btn {
  background: #e2e8f0;
  color: #4a5568;
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;
}

.cancel-btn:hover:not(:disabled) {
  background: #cbd5e0;
}

.save-btn {
  background: #667eea;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;
}

.save-btn:hover:not(:disabled) {
  background: #5a67d8;
}

.cancel-btn:disabled,
.save-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* 비밀번호 변경 버튼 */
.change-password-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 12px 24px;
  border: none;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.change-password-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 20px -5px rgba(102, 126, 234, 0.3);
}

/* 반응형 디자인 */
@media (max-width: 768px) {
  .profile-header {
    flex-direction: column;
    gap: 16px;
    align-items: flex-start;
  }
  
  .profile-header h1 {
    font-size: 28px;
  }
  
  .profile-section {
    padding: 24px;
  }
  
  .info-item {
    grid-template-columns: 1fr;
    gap: 8px;
  }
  
  .info-item .label {
    font-weight: 600;
  }
}

@media (max-width: 480px) {
  .profile-container {
    padding: 20px 16px;
  }
  
  .profile-section {
    padding: 20px;
  }
  
  .form-actions {
    flex-direction: column;
  }
  
  .cancel-btn,
  .save-btn {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/css/profile.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,aAAa;AACb;;EAEE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;EAGE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,aAAa;AACf;;AAEA;;;EAGE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;;EAGE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,qDAAqD;AACvD;;AAEA,YAAY;AACZ;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,QAAQ;EACV;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;AACF","sourcesContent":["/* 프로필 페이지 스타일 */\n.profile-container {\n  min-height: 100vh;\n  background: #f7fafc;\n  padding: 40px 20px;\n}\n\n.profile-wrapper {\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.profile-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 32px;\n}\n\n.profile-header h1 {\n  font-size: 32px;\n  font-weight: bold;\n  color: #2d3748;\n}\n\n.logout-btn {\n  background: #e53e3e;\n  color: white;\n  padding: 10px 20px;\n  border: none;\n  border-radius: 6px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.logout-btn:hover {\n  background: #c53030;\n}\n\n.message {\n  padding: 12px 16px;\n  border-radius: 6px;\n  margin-bottom: 20px;\n  font-size: 14px;\n}\n\n.message.success {\n  background: #c6f6d5;\n  color: #22543d;\n  border: 1px solid #9ae6b4;\n}\n\n.message.error {\n  background: #fed7d7;\n  color: #9b2c2c;\n  border: 1px solid #fc8181;\n}\n\n.profile-card {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n}\n\n.profile-section {\n  padding: 32px;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.profile-section:last-child {\n  border-bottom: none;\n}\n\n.section-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n}\n\n.section-header h2 {\n  font-size: 20px;\n  font-weight: 600;\n  color: #2d3748;\n}\n\n.edit-btn {\n  background: #667eea;\n  color: white;\n  padding: 8px 16px;\n  border: none;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.edit-btn:hover {\n  background: #5a67d8;\n}\n\n/* 프로필 정보 표시 */\n.profile-info {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.info-item {\n  display: grid;\n  grid-template-columns: 120px 1fr;\n  gap: 16px;\n  padding: 12px 0;\n  border-bottom: 1px solid #f7fafc;\n}\n\n.info-item:last-child {\n  border-bottom: none;\n}\n\n.info-item .label {\n  font-weight: 500;\n  color: #718096;\n  font-size: 14px;\n}\n\n.info-item .value {\n  color: #2d3748;\n  font-size: 14px;\n}\n\n/* 프로필 수정 폼 */\n.profile-form,\n.password-form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.profile-form .form-group,\n.password-form .form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.profile-form label,\n.password-form label {\n  font-size: 14px;\n  font-weight: 500;\n  color: #4a5568;\n}\n\n.profile-form input,\n.profile-form select,\n.password-form input {\n  padding: 10px 14px;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  font-size: 14px;\n  transition: all 0.2s;\n  outline: none;\n}\n\n.profile-form input:focus,\n.profile-form select:focus,\n.password-form input:focus {\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.profile-form input.error,\n.password-form input.error {\n  border-color: #fc8181;\n}\n\n.profile-form input:disabled,\n.profile-form select:disabled,\n.password-form input:disabled {\n  background-color: #f7fafc;\n  cursor: not-allowed;\n}\n\n.error-text {\n  font-size: 12px;\n  color: #e53e3e;\n}\n\n.form-actions {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n  margin-top: 12px;\n}\n\n.cancel-btn {\n  background: #e2e8f0;\n  color: #4a5568;\n  padding: 10px 20px;\n  border: none;\n  border-radius: 6px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.cancel-btn:hover:not(:disabled) {\n  background: #cbd5e0;\n}\n\n.save-btn {\n  background: #667eea;\n  color: white;\n  padding: 10px 20px;\n  border: none;\n  border-radius: 6px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.save-btn:hover:not(:disabled) {\n  background: #5a67d8;\n}\n\n.cancel-btn:disabled,\n.save-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* 비밀번호 변경 버튼 */\n.change-password-btn {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  padding: 12px 24px;\n  border: none;\n  border-radius: 6px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.change-password-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 10px 20px -5px rgba(102, 126, 234, 0.3);\n}\n\n/* 반응형 디자인 */\n@media (max-width: 768px) {\n  .profile-header {\n    flex-direction: column;\n    gap: 16px;\n    align-items: flex-start;\n  }\n  \n  .profile-header h1 {\n    font-size: 28px;\n  }\n  \n  .profile-section {\n    padding: 24px;\n  }\n  \n  .info-item {\n    grid-template-columns: 1fr;\n    gap: 8px;\n  }\n  \n  .info-item .label {\n    font-weight: 600;\n  }\n}\n\n@media (max-width: 480px) {\n  .profile-container {\n    padding: 20px 16px;\n  }\n  \n  .profile-section {\n    padding: 20px;\n  }\n  \n  .form-actions {\n    flex-direction: column;\n  }\n  \n  .cancel-btn,\n  .save-btn {\n    width: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
